import styled, { css } from 'styled-components';

import Button from './base/Button';
import { StyledCard } from './base/Card';
import { IconName } from './base/Icon';
import Text from './base/Text';
import { Div } from './helpers/StyledUtils';

interface EmptyStateProps {
  title: string;
  description: string;
  asset: string;
  asset_position?: 'flex-start' | 'flex-end' | 'center' | 'background';
  cta: {
    icon: IconName;
    label: string;
    onClick?: () => void;
    to?: string;
  };
}

const StyledEmptyStateCard = styled(StyledCard)<{ bg_url_asset?: string }>(({
  theme,
  bg_url_asset,
}) => {
  const bg_asset = bg_url_asset || `empty_state_bg_${theme.mode}.svg`;
  const bg_url = `/images/empty/${bg_asset}`;
  return css`
    width: 840px;
    height: 472px;
    display: flex;
    align-self: center;
    border: ${theme.border};
    background-image: url(${bg_url});
    background-size: cover;
    background-position: end center;
    background-repeat: no-repeat;
  `;
});

export const StyledEmptyStateWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyState = ({
  title,
  description,
  cta,
  asset,
  asset_position = 'center',
}: EmptyStateProps) => {
  return (
    <Div flex={{ align: 'center', justify: 'center', grow: true }}>
      <StyledEmptyStateCard
        muted
        bg_url_asset={asset_position === 'background' ? asset : undefined}>
        <Div w={50} flex={{ align: 'center' }}>
          <Div p={{ x: 10 }}>
            <Text bold size="l" m={{ b: 2 }}>
              {title}
            </Text>
            <Text muted>{description}</Text>
            {cta && (
              <Button m={{ t: 8 }} primary icon={cta.icon} to={cta.to} onClick={cta.onClick}>
                {cta.label}
              </Button>
            )}
          </Div>
        </Div>
        <Div w={50} flex={{ align: asset_position, justify: 'center' }}>
          {asset_position !== 'background' ? <img src={asset} /> : null}
        </Div>
      </StyledEmptyStateCard>
    </Div>
  );
};

const StyledEmptyResultsCard = styled.div(({ theme }) => {
  const bg_url = `/images/empty/empty_gradient_${theme.mode}.svg`;
  return css`
    background-image: url(${bg_url});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 480px;
    height: 480px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    justify-content: center;
    align-items: center;
    align-self: center;
  `;
});

export const EmptyResults = ({ label, cta }: { label: string; cta?: React.ReactNode }) => {
  return (
    <Div flex={{ align: 'center', justify: 'center' }}>
      <StyledEmptyResultsCard>
        <Text semi muted size="l">
          {label}
        </Text>
        {cta || null}
      </StyledEmptyResultsCard>
    </Div>
  );
};

export default EmptyState;
